<template>
  <div>
    <el-tree
      ref="tree"
      @node-click="handleNodeClick"
      node-key="fileId"
      :highlight-current="true"
      :props="defaultProps"
      :load="loadNode"
      lazy
      :expand-on-click-node="false"
      :default-expanded-keys="uniList"
      :current-node-key="nodeKey"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span class="treeIcon" v-if="crud">
          <i
            v-if="node.level == 1"
            class="icon-ccui-add-sup"
            @click.stop="() => addClick(node, data)"
          ></i>
          <img
            v-if="node.level < 6 && node.level > 1"
            src="@/assets/images/add.png"
            class="treeImg"
            @click.stop="() => addClick(node, data)"
          />
          <img
            v-if="node.level > 1"
            src="@/assets/images/del.png"
            class="treeImg"
            @click.stop="() => remove(node, data)"
          />
          <img
            v-if="node.level > 1"
            src="@/assets/images/edit.png"
            class="treeImg"
            @click.stop="() => editItem(node, data)"
          />
        </span>
      </span>
    </el-tree>
    <el-dialog
      class="uploadDialog"
      :title="editName ? '文件夹重命名' : '新建文件夹'"
      ref="dialog"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form :model="Form" :rules="rules" ref="Form" @submit.native.prevent>
        <el-form-item
          :label="editName ? '文件夹重命名:' : '文件夹命名:'"
          prop="name"
        >
          <el-input
            class="folderInput"
            placeholder="请输入文件夹名称"
            v-model.trim="Form.name"
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="closeDialog"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="() => ensure('Form')"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addImageFile,
  qryImageFile,
  delImageFile,
  renameImageFile
} from "./pictureManage";
// import { getArgs } from "@/basa/utils";
export default {
  name: "treeList",
  props: {
    crud: {
      // 是否开启树的增删改
      type: Boolean,
      default() {
        return false;
      }
    },
    defaultProps: {
      // 树的初始化属性
      type: Object,
      default() {
        return {
          label: "fileName",
          isLeaf: "leaf"
        };
      }
    },
    reNodeName: {
      // 将数据缓存到本地的key
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      type: "", // 判断是否是删除操作
      fileId: "", // 当前节点的fileId
      node: [], // 树节点
      nodeKey: 0, // 当前选中的节点
      reNodeData: [], // 需要缓存的节点列表
      Form: {
        // 修改、新建节点的表单
        name: ""
      }, //文件夹
      rules: {
        // 修改、新建节点的表单校验
        name: [
          {
            required: true,
            message: "请输入文件夹名称",
            trigger: "blur"
          }
        ]
      }, //必填规则
      editName: false, //判断重命名或新建文件夹
      dialogVisible: false, //文件夹是否打开
      uniList: [], //存储uni
      localFile: [] //本地缓存fileid集合
    };
  },
  computed: {
    agentId: function() {
      return '' //getArgs("a");
    }
  },
  mounted() {
    // 进入页面时，查看是否有记录，有则回显
    let reNodeName = JSON.parse(localStorage.getItem(this.reNodeName)) || [0];
    let fileId = reNodeName[reNodeName.length - 1];
    if (!fileId) {
      qryImageFile({
        parentId: 0,
        shopId: localStorage.getItem("shopId")
      }).then(res => {
        if (res.data.data.imageFiles.length !== 0) {
          this.$emit("updateImgList", {
            fileId: res.data.data.imageFiles[0].fileId
          });
          this.$emit("getFileId", res.data.data.imageFiles[0].fileId);
        }
      });
    } else {
      this.$emit("updateImgList", { fileId });
      this.$emit("getFileId", fileId);
    }
  },
  methods: {
    // 更新指定的node
    updateNode(node) {
      let parentId = node.data.fileId;
      this.$emit("getId", parentId);
      qryImageFile({
        parentId,
        shopId: localStorage.getItem("shopId")
      }).then(res => {
        node.childNodes.splice(0, node.childNodes.length);
        node.doCreateChildren(res.data.data.imageFiles);
        this.uniList = [];
        while (node.level !== 0) {
          this.uniList.unshift(node.data.fileId);
          node = node.parent;
        }
      });
    },
    // 懒加载 打开树时调用
    // 回显时 调用
    // 添加/删除子节点时 调用
    loadNode(node, resolve) {
      console.log(node, "node");
      let reNodeName = JSON.parse(localStorage.getItem(this.reNodeName)) || [0]; // 回显的节点列表数据
      let fileId = reNodeName[reNodeName.length - 1]; // 回显的节点数据
      if (node.level === 0) {
        // 加载首节点时
        let data = [
          {
            fileName: "全部图片",
            fileId: 0,
            parentId: 0,
            leaf: true,
            isEnd: 1
          }
        ]; // 首节点数据
        if (reNodeName.length != 1) {
          let tempLIst = JSON.parse(JSON.stringify(reNodeName));
          tempLIst.pop();
          this.uniList = tempLIst; // 存放需要自动展开的节点的列表
        } else {
          this.uniList = [0];
        }
        resolve(data);
      } else {
        // 加载非首节点时
        qryImageFile({
          parentId: node.data.fileId,
          shopId: localStorage.getItem("shopId")
        }).then(res => {
          console.log("报错", node);
          resolve(res.data.data);
          if (this.type === "del") {
            this.nodeKey = 0;
            this.$refs.tree.setCurrentKey(0);
            this.type = "";
          } else if (
            node &&
            node.data &&
            node.data.fileId !== "undefined" &&
            node.childNodes[0] &&
            node.childNodes[0].data.fileId
          ) {
            console.log("报错", node);
            let isDefault =
              reNodeName.length == 1 && node.level === 1
                ? node.childNodes[0].data.fileId
                : fileId;
            this.nodeKey = isDefault;
            this.$refs.tree.setCurrentKey(isDefault);
          }
          console.log("this.nodeKey", this.nodeKey);
        });
      }
    },
    // 点击树节点
    handleNodeClick(nodes, node, data) {
      let reNodeData = [];
      let type = "tree";
      let fileId = nodes.fileId;
      if (nodes.fileId == 0) {
        fileId = null;
      }
      this.$emit("updateImgList", { fileId: fileId });
      this.$emit("getFileId", fileId, type);
      while (node.level !== 0) {
        reNodeData.unshift(node.data.fileId);
        node = node.parent;
      }
      localStorage.setItem(this.reNodeName, JSON.stringify(reNodeData));
    },
    //新建文件夹弹窗打开
    addClick(node) {
      this.Form.name = "";
      this.dialogVisible = true;
      this.editName = false;
      this.node = node;
    },
    //编辑文件夹打开
    editItem(node, data) {
      this.dialogVisible = true;
      this.node = node;
      this.Form.name = data.label;
      this.editName = true;
    },
    //删除文件夹
    remove(node) {
      this.node = node;
      this.$confirm("确认删除文件夹及其所含图片？", "操作提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      }).then(() => {
        delImageFile({
          agentId: this.agentId,
          fileId: node.data.fileId
        }).then(res => {
          let { code } = res.data;
          if (code === "0") {
            this.$message({
              showClose: true,
              message: " 删除成功",
              type: "success",
              ccuiCustom: true,
              duration: 3000
            });
            this.renew(node, "", 2);
            let localStorageList = [
              "pictureManage",
              "selectPhonePicture",
              "selectPCPicture",
              "selectPicture"
            ];
            localStorageList.map(res => {
              let temp = JSON.parse(localStorage.getItem(res));
              if (temp && temp.includes(node.data.fileId)) {
                this.updataLocalStorage(res, node.data.fileId);
              }
            });
          }
          this.updateNode(this.node.parent);
          this.type = "del";
          this.$emit("getFileId");
          console.log("删除", node);
          //删除文件夹后重新展开父节点
          node.parent.loaded = false;
          node.parent.expand();
        });
      });
    },
    // 更新要存的数据
    updataLocalStorage(name, fileId) {
      let temp = JSON.parse(localStorage.getItem(name));
      let num = temp.length;
      let index = temp.indexOf(fileId);
      temp.splice(index, num);
      localStorage.setItem(name, JSON.stringify(temp));
    },
    //确定按钮-添加或修改文件夹
    ensure(Form) {
      this.$refs[Form].validate(valid => {
        if (valid) {
          let node = this.node;
          let fileName = this.Form.name;
          this.dialogVisible = false;
          if (this.editName === false) {
            addImageFile({ fileName, parentId: node.data.fileId }).then(() => {
              this.updateNode(node);
              this.$message({
                showClose: true,
                message: "新增成功！",
                type: "success",
                ccuiCustom: true
              });
            });
          } else if (this.editName === true) {
            renameImageFile({ fileName, fileId: node.data.fileId }).then(() => {
              this.updateNode(node.parent);
            });
            this.renew(node, fileName, 1);
            this.$message({
              showClose: true,
              message: "重命名成功！",
              type: "success",
              ccuiCustom: true
            });
          }
        }
      });
    },
    //删除或重名时时更新本地存储
    renew(node, fileName, type) {
      this.localFile = [];
      console.log("node", node);
      let localObj = JSON.parse(localStorage.getItem("uploadpicture"));
      if (localObj && localObj[this.agentId]) {
        if (node.data.fileId == localObj[this.agentId].fileid && type == 2) {
          delete localObj[this.agentId];
          console.log(localObj, "localObj");
        }
        if (type == 1) {
          localObj[this.agentId].value = fileName;
        }
        localStorage.setItem("uploadpicture", JSON.stringify(localObj));
      }
      console.log(localObj, "localObj");
    },
    //关闭文件夹弹框
    closeDialog() {
      this.dialogVisible = false;
      this.$refs["Form"].clearValidate();
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-ccui-add-sup {
  color: black;
  &:hover {
    color: #ff142f;
  }
}
.treeImg {
  margin-right: 5px;
}
.treeImg:hover {
  color: #ff142f;
}
.icon-ccui-delete {
  color: black;
  &:hover {
    color: #ff142f;
  }
}

.icon-ccui-edit {
  color: black;
  &:hover {
    color: #ff142f;
  }
}
.el-tree-node:focus > .el-tree-node__content {
  color: #ff142f;
}
.el-tree {
  width: 270px;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4a4a4a;
  line-height: 18px;
}
.treeIcon {
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.custom-tree-node {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.el-tree-node__expand-icon {
  color: #9b9b9b;
}
.treeIcon i {
  margin-right: 4px;
  font-weight: 600;
}
/deep/.el-dialog__body {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.el-dialog__body.el-form {
  margin-top: 45px;
}
.folderInput {
  width: 200px;
  margin-left: 10px;
}
/deep/.el-form-item__content {
  display: flex;
}
/deep/.treeImg:hover {
  transform: scale(1.2);
}
</style>
